const BASE_URL = (process.env.REACT_APP_API_ROOT_STORAGE || process.env.REACT_APP_API_ROOT_DEFAULT) + '/plugins/storage/';

export const urls = {
    storage_documents_details: BASE_URL + 'documents/:id/',
    storage_file: BASE_URL + 'files/'
}